var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommanderBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.85,31.01H2.15c-.62,0-1.13-.51-1.13-1.13V7.9c0-.62.51-1.13,1.13-1.13h30.7c.62,0,1.13.51,1.13,1.13v5.67H11.79v9.85h22.19v6.46c0,.62-.51,1.13-1.13,1.13Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.85,
    y1: 13.53,
    x2: 32.85,
    y2: 23.42,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.86,
    cy: 19.45,
    r: 0.85,
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.24,
    cy: 19.45,
    r: 0.85,
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.06,
    cy: 19.45,
    r: 0.85,
    style: {
      fill: "currentColor"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommanderBox);
export default __webpack_public_path__ + "static/media/commander_box.fcd09a20400cce25c9dfe7f889c3881d.svg";
export { ForwardRef as ReactComponent };